function initCarousel(carouselId, context) {
    const carousel = context.getElementById(carouselId);
    if (!carousel) {
      console.error(`Carousel with ID ${carouselId} does not exist.`);
      return;
    }
  
    const items = context.querySelectorAll(`#${carouselId} .carousel-item`);
    const totalItems = items.length;
    if (totalItems === 0) {
      console.error(`No carousel items found in carousel with ID ${carouselId}.`);
      return;
    }
  
    let currentIndex = 0;
  
    function showSlide(index) {
      items.forEach((item, i) => {
        item.classList.toggle('block', i === index);
        item.classList.toggle('hidden', i !== index);
        const indicator = context.getElementById(
          `indicator-${carouselId.split('-')[1]}-${i}`
        );
        if (indicator) {
          indicator.classList.toggle('bg-collins-1', i === index);
          indicator.classList.toggle('bg-collins-3', i !== index);
        }
      });
      currentIndex = index;
    }
  
    function nextSlide() {
      const nextIndex = (currentIndex + 1) % totalItems;
      showSlide(nextIndex);
    }
  
    function prevSlide() {
      const prevIndex = (currentIndex - 1 + totalItems) % totalItems;
      showSlide(prevIndex);
    }
  
    function goToSlide(index) {
      showSlide(index);
    }
  
    let touchStartX = 0;
    let touchEndX = 0;
  
    function handleTouchStart(event) {
      touchStartX = event.changedTouches[0].clientX;
    }
  
    function handleTouchEnd(event) {
      touchEndX = event.changedTouches[0].clientX;
      handleSwipeGesture();
    }
  
    function handleSwipeGesture() {
      if (touchEndX < touchStartX - 50) {
        nextSlide();
      } else if (touchEndX > touchStartX + 50) {
        prevSlide();
      }
    }
  
    items.forEach(item => {
      item.addEventListener('touchstart', handleTouchStart);
      item.addEventListener('touchend', handleTouchEnd);
    });
  
    const nextButton = carousel.querySelector('.next-slide');
    const prevButton = carousel.querySelector('.prev-slide');
  
    if (nextButton) {
      nextButton.addEventListener('click', nextSlide);
    } else {
      console.warn(`Next button not found in carousel with ID ${carouselId}.`);
    }
  
    if (prevButton) {
      prevButton.addEventListener('click', prevSlide);
    } else {
      console.warn(
        `Previous button not found in carousel with ID ${carouselId}.`
      );
    }
  
    const indicators = carousel.querySelectorAll('.carousel-indicators button');
    if (indicators.length === 0) {
      console.warn(`No indicators found for carousel with ID ${carouselId}.`);
    }
    indicators.forEach((indicator, index) => {
      indicator.addEventListener('click', () => goToSlide(index));
    });
  
    showSlide(0);
  }
  
  export function initCarouselControls(context) {
    context.querySelectorAll('.carousel').forEach(carousel => {
      const paragraphId = carousel.id;
      initCarousel(paragraphId, context);
    });
  }
  